import type { TemplateSlot } from "../utils/derive-template";
import { DAY_LABELS, WEEK_ORDER } from "../utils/derive-template";
import { ScheduleDayColumn } from "./ScheduleDayColumn";

interface ScheduleWeeklyDesktopProps {
  readonly weeklySlots: ReadonlyMap<number, readonly TemplateSlot[]>;
  readonly onEditSlot: (slot: TemplateSlot) => void;
  readonly onAddSlot: (day: number) => void;
  readonly onContextMenu: (slot: TemplateSlot, anchorRect: DOMRect) => void;
}

export function ScheduleWeeklyDesktop({
  weeklySlots,
  onEditSlot,
  onAddSlot,
  onContextMenu,
}: ScheduleWeeklyDesktopProps) {
  return (
    <section className="hidden md:block w-full">
      <h2 className="text-sm font-semibold text-ink mb-4">Hebdomadaire</h2>
      <div className="grid grid-cols-7 gap-4">
        {WEEK_ORDER.map((day) => {
          const slots = weeklySlots.get(day) ?? [];
          return (
            <ScheduleDayColumn
              key={day}
              dayLabel={DAY_LABELS[day]}
              slots={slots}
              onEditSlot={onEditSlot}
              onAddSlot={() => onAddSlot(day)}
              onContextMenu={onContextMenu}
            />
          );
        })}
      </div>
    </section>
  );
}
